import * as Yup from 'yup';
import { DictionaryDirpAuthor } from './../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryDirpAuthor>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
